export default __webpack_public_path__ + "static/char-v-32-zh-Hant-2415771c008359006dee05e1661a52b6.mp4";